
const token = ({name, type, startIndex, endIndex, value}) => ({
    name,
    type,
    startIndex,
    endIndex,
    value
});

export {token}